import BaseAxiosRequest from '@r1-frontend/do-request/core/BaseAxiosRequest';
import { DoRequest } from '@r1-frontend/do-request/core/DoRequest';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

export const doRequest = new DoRequest<IRequest>(new BaseAxiosRequest());
